import React from 'react';
import './Expert.scss';
import SectionTitleUp from '../../components/SectionTitle/SectionTitleUp';
import { BsFillCheckCircleFill } from "react-icons/bs";
import expertImg from '../../assets/expert.png';

const Expert = () => {
    return (
        <section className='expert-section' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="expert-text">
                            <SectionTitleUp
                                subTitle="OUR COMMITMENT TO SUSTAINABILITY"
                                title="Healing smiles & planet together ! We are Sri Lanka's pioneering sustainable health brand!"
                                description="All good things begin with a smile! We take great pride in practicing green dentistry. Here are some of our sustainability efforts:"
                            />

                            <ol>

                                <li>Transformation to a digital office</li>
                                <li>Minimizing single-use plastics</li>
                                <li>Maximizing utilization of sunlight</li>
                                <li>Using LED lights</li>
                                <li>Employing energy-efficient equipment, including inverter air conditioners</li>
                                <li>Reducing waste</li>
                                <li>Conserving water</li>
                                <li>Using reclaimed wood</li>
                                <li>Providing complimentary oral cancer screenings</li>
                                <li>Committing to reducing our carbon footprint</li>
                            </ol>

                            <ul>
                                <li>
                                    <BsFillCheckCircleFill />
                                    Join 6thLane Dentistry to combat environmental pollution and global warming. ( <a href="https://facebook.com/6thlanedentistry" target="_blank" rel="noopener noreferrer">
                                        Facebook </a> , <a href="https://www.youtube.com/channel/UCFULIQrsE94fGkHLuZHHckw" target="_blank" rel="noopener noreferrer">
                                        YouTube </a> )
                                </li>
                                <li>
                                    <BsFillCheckCircleFill />
                                    We offer complimentary oral cancer screenings. Please schedule your check-up every 6 months. ( <a href="tel:0094777612834">Call 0094777612834 now</a> )
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="expert-img">
                            <img src={expertImg} alt="expert" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Expert;